import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService implements CanActivate {

  constructor(
    public auth: AuthService,
    public router: Router,
    private location: Location
  ) { }

  canActivate() {

    if (!this.auth.isAdminAuthenticated()) {
      this.router.navigate(['login-admin']);
      return false;
    }

    return true;
  }
}
